/**
 * Client-side gate for staff-only money choices (#2691): keeping the price on
 * a pricier slot, booking a priced court for free, and approving or declining
 * player move requests. These need the owner, manager or front desk role.
 *
 * The backend derives that role from the caller's facility action set:
 * facility:schedule plus at least one of manage (owner), refund_override or
 * court (manager), or checkin (front desk). facility:schedule alone is a coach.
 * This mirrors that rule from the server-computed `allowed_actions` so the UI
 * hides choices the server would refuse; the server still enforces it
 * (403 waive_requires_staff_role).
 */
const STAFF_ROLE_ACTIONS = [
  "facility:manage",
  "facility:refund_override",
  "facility:court",
  "facility:checkin",
] as const;

export function hasStaffScheduleRole(
  allowedActions: readonly string[] | null | undefined,
): boolean {
  if (!allowedActions?.includes("facility:schedule")) return false;
  return STAFF_ROLE_ACTIONS.some((action) => allowedActions.includes(action));
}
